









import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'NavTitle'
})
export default class extends Vue {
  // 子组件prop声明: @Prop({ type: String, ... }) ts类型声明(非空断言) pravite title!: string
  @Prop({ type: String }) private title!: string
  @Prop({ type: Boolean, default: false }) private showTitle!: boolean
}
